import type { VoidFunctionComponent } from 'react';

import { renderPackage, renderRevision } from '../../../../../shared/helpers/renderLocator';
import FetcherIcon from '../../../generic/FetcherIcon';
import type { LocatorParts } from '../../../../../shared/Locator';

import styles from './PackageLocator.module.less';

type Props = {
  /**
   * The parts of a Locator (you can get this by doing `Locator.parse(someLocator)`);
   */
  locatorParts: LocatorParts;
  /**
   * If the "in" prefix should be displayed.
   */
  isPrefixDisplayed?: boolean;
  /**
   * Preferred package title, if any. If provided,
   * it prefers this title over raw package identifier.
   */
  preferredPackageTitle?: string;
};

/**
 * PackageLocator formats and displays a locator nicely with
 * the fetcher icon, helping the user contextualize where the issue
 * they are looking at is used.
 *
 * eg: "in <FetcherIcon /> lodash (1.2.3)"
 */
const PackageLocator: VoidFunctionComponent<Props> = ({
  locatorParts,
  isPrefixDisplayed = true,
  preferredPackageTitle = undefined,
}) => (
  <div className={styles.locator}>
    {isPrefixDisplayed && (
      <span className={styles.in}>
        in
      </span>
    )}
    <FetcherIcon fetcher={locatorParts.fetcher || ''} />
    <span className={styles.pkg}>
      {preferredPackageTitle || renderPackage(locatorParts)}
    </span>
    {locatorParts.revision && (
      <span>
        ({renderRevision(locatorParts)})
      </span>
    )}
  </div>
);

export default PackageLocator;
